import { StyledModal } from '@app/components/modal/Modal';
import useTextAgentActions from '@app/hooks/text-agents/useTextAgentActions';
import type { AITextAgent } from '@app/services/text-agent.types';
import type { ModalProps } from 'antd';

export type TextAgentDeleteModalProps = ModalProps & {
    title?: string;
    data?: AITextAgent;
};

export const TextAgentDeleteModal = ({
    title = 'Delete AI Text Agent',
    data,
    ...props
}: TextAgentDeleteModalProps) => {
    const { deleteTextAgent } = useTextAgentActions();

    return (
        <StyledModal
            title={title}
            okText="Delete"
            {...props}
            confirmLoading={deleteTextAgent?.isPending}
            onOk={(e) => {
                const formData = { id: data?.id || 0 };
                deleteTextAgent.mutate(formData, {
                    onSuccess: () => {
                        if (props?.onOk) {
                            props.onOk(e);
                        }
                    },
                });
            }}>
            <p>Are you sure you want to remove this AI Text Agent?</p>
        </StyledModal>
    );
};

export default TextAgentDeleteModal;
